import fetchAPI from "./fetchAPI"

export async function createGravityFormEntry(context, id, data, token) {
  const { createGravityFormEntry } = await fetchAPI(
    `mutation($context: String!, $id: ID!, $data: JSON!, $token: String!) {
          createGravityFormEntry(context: $context, id: $id, data: $data, token: $token){
            error
            data
          }
        }`,
    {
      variables: { context, id, data: JSON.stringify(data), token }
    }
  )

  return createGravityFormEntry
}
